import $ from "jquery";
import Field from "./../field";

const Checkboxes = (($) => {
  class Checkboxes extends Field {
    getValue() {
      let values = [];

      this._inputs.forEach((input) => {
        if (input.checked) {
          values.push(input.value);
        }
      });

      if (values.length == 0) {
        values = null;
      }

      return values;
    }

    render() {
      const self = this;

      let id = this.getForm().getID() + "_field_" + this._field.formFieldID;

      this._element = document.createElement("fieldset");
      this._element.classList.add("ion-form-group");
      this._element.classList.add("ion-form-group-checkbox");

      let isRequired = this.getSetting("isRequired", false);
      if (isRequired == "1") {
        this._element.classList.add("ion-is-required");
      }

      // Label
      this._label = document.createElement("legend");
      this._label.htmlFor = id;
      this._label.innerText = this._field.label;
      this._element.appendChild(this._label);

      // Default Value
      let defaultValue = this.getSetting("defaultValue");

      // Options
      this._inputs = [];
      let optionString = this.getSetting("options", "");
      let options = optionString.split("\r\n");
      options.forEach(function (optionString, index) {
        if (optionString && optionString.length > 0) {
          let input = document.createElement("input");
          input.type = "checkbox";
          (input.name = self._field.slug + "[]"), (input.id = id + "_" + index);
          input.value = optionString;
          input.ariaLabel = optionString;

          if (defaultValue == optionString) {
            input.checked = true;
          }

          let label = document.createElement("label");
          label.htmlFor = id + "_" + index;

          let labelText = document.createElement("span");
          labelText.innerText = optionString;

          self._inputs.push(input);
          label.appendChild(input);
          label.appendChild(labelText);
          self._element.appendChild(label);
        }
      });

      // Instructions
      let instructions = this._renderInstructions();
      if (instructions) {
        this._element.appendChild(instructions);
      }

      // Messages
      this._renderMessages();
      if (this._messages) {
        this._element.appendChild(this._messages);
      }
    }
  }

  return Checkboxes;
})($);

export default Checkboxes;
